var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconLock = function SvgIconLock(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_1624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 7.07373V4.57373C11 3.77808 10.6839 3.01502 10.1213 2.45241C9.55871 1.8898 8.79565 1.57373 8 1.57373C7.20435 1.57373 6.44129 1.8898 5.87868 2.45241C5.31607 3.01502 5 3.77808 5 4.57373V7.07373M4.5 14.5737H11.5C11.8978 14.5737 12.2794 14.4157 12.5607 14.1344C12.842 13.8531 13 13.4716 13 13.0737V8.57373C13 8.17591 12.842 7.79438 12.5607 7.51307C12.2794 7.23177 11.8978 7.07373 11.5 7.07373H4.5C4.10218 7.07373 3.72064 7.23177 3.43934 7.51307C3.15804 7.79438 3 8.17591 3 8.57373V13.0737C3 13.4716 3.15804 13.8531 3.43934 14.1344C3.72064 14.4157 4.10218 14.5737 4.5 14.5737Z",
    stroke: "#353333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_1624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.0737305)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconLock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_lock.0ca539f1009715a027ee0576c12f8c8f.svg";